var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('MotorS',{attrs:{"cp":_vm.cp,"childrens":_vm.childrens,"idTela":_vm.idTela,"state":Object.assign({}, _vm.state)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }